module.exports = __webpack_public_path__ + "static/img/saimenInstallForMac_pic15.0cdbf10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForMac/saimenInstallForMac_pic15.png
// module id = 566
// module chunks = 1